import { IActor } from 'redhotpie-shared-lib/interfaces/INewFeed';
import * as utils from '../functions/utils';
import { IMainPhoto } from 'redhotpie-shared-lib/interfaces/IUser';
import Photo, { IPhotoData } from './photo';

interface OwnerData {
  UserID: number;
  Username?: string;
  UserName?: string;
  MemberType: number;
  ProfilePhoto?: IPhotoData;
  MainPhoto?: IPhotoData;
  Location?: string;
  MemberTypeTitle?: string;
  IsViewable?: boolean;
  MemberID?: number | null;
  ArticleAuthorID?: number;
  ImageUrl?: string;
  Name?: string;
}

export default class Owner {
  id: number | null;
  userId: number;
  title: string;
  userName: string;
  memberType: number;
  mainPhoto: IMainPhoto;
  location: string;
  memberTypeTitle: string;
  isViewable: boolean | undefined;

  constructor() {
    this.id = null;
    this.userId = -1;
    this.userName = '';
    this.title = '';
    this.memberType = -1;
    this.mainPhoto = {};
    this.location = '';
    this.memberTypeTitle = '';
    this.isViewable = true;
  }

  static mappingObject(_ojb: OwnerData): IActor {
    const ojb = new Owner();
    ojb.id = _ojb.UserID || _ojb.MemberID || _ojb.ArticleAuthorID || -1;
    ojb.userId = _ojb.UserID || _ojb.MemberID || _ojb.ArticleAuthorID || -1;
    ojb.userName = _ojb.Username || _ojb.UserName || _ojb.Name || '';
    ojb.title = _ojb.Username ? _ojb.Username : '';
    ojb.memberType = _ojb.MemberType || -1;
    ojb.mainPhoto = _ojb.ProfilePhoto
      ? Photo.mappingCustomObject(_ojb.ProfilePhoto)
      : _ojb.MainPhoto
        ? Photo.mappingCustomObject(_ojb.MainPhoto)
        : _ojb.ImageUrl
          ? { fullUrl: _ojb.ImageUrl, thumbUrl: _ojb.ImageUrl }
          : {};
    ojb.location = _ojb.Location ? _ojb.Location : '';
    ojb.memberTypeTitle = _ojb.MemberTypeTitle ? _ojb.MemberTypeTitle : '';
    ojb.isViewable = utils.hasOwnProperty(_ojb, 'IsViewable') ? _ojb.IsViewable : true;

    return ojb as IActor;
  }

  static mappingObjects(_data: OwnerData[]): IActor[] {
    return _data.map(item => Owner.mappingObject(item));
  }
}
